import {DestinationPoint} from "./destination-point";

export class InitOrder {
  points: DestinationPoint[] = [];
  tierIdentifier: string = '';
}
